import { css } from '@eti/styles';
import { Text, textVariants } from '@etg/wings';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const columnDetailStyles = css`
  align-items: center;
  display: flex;
  justify-content: center;
  ${rowItemSize};
`;
const ColumnDetail = _ref => {
  let {
    columnName
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    className: columnDetailStyles,
    variant: textVariants._14_BOLD,
    children: columnName
  });
};
export default ColumnDetail;
//# sourceMappingURL=ColumnDetail.js.map